import { useState } from 'react';
import { settings, BRANCHES, GRADE_LEVELS } from '@/mocks/mockData';

export default function AyarlarPage() {
  const [platformName, setPlatformName] = useState(settings.platformName);
  const [commissionRate, setCommissionRate] = useState(settings.defaultCommissionRate);
  const [trialDuration, setTrialDuration] = useState(settings.defaultTrialDuration);
  const [branches, setBranches] = useState<string[]>(settings.branches);
  const [newBranch, setNewBranch] = useState('');
  const [grades, setGrades] = useState<string[]>(settings.gradeLevels);
  const [newGrade, setNewGrade] = useState('');
  const [saved, setSaved] = useState(false);
  const [activeSection, setActiveSection] = useState('genel');

  const save = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const removeBranch = (b: string) => setBranches(prev => prev.filter(x => x !== b));
  const addBranch = () => { if (newBranch.trim() && !branches.includes(newBranch.trim())) { setBranches(prev => [...prev, newBranch.trim()]); setNewBranch(''); } };
  const removeGrade = (g: string) => setGrades(prev => prev.filter(x => x !== g));
  const addGrade = () => { if (newGrade.trim() && !grades.includes(newGrade.trim())) { setGrades(prev => [...prev, newGrade.trim()]); setNewGrade(''); } };

  const sections = [
    { id: 'genel', label: 'Genel Ayarlar', icon: 'ri-settings-line' },
    { id: 'branches', label: 'Branş Listesi', icon: 'ri-book-2-line' },
    { id: 'grades', label: 'Sınıf Seviyeleri', icon: 'ri-school-line' },
    { id: 'statuses', label: 'Durum Listesi', icon: 'ri-list-check' },
    { id: 'roles', label: 'Kullanıcı Rolleri', icon: 'ri-user-settings-line' },
  ];

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-800">Ayarlar</h1>
        <p className="text-slate-500 text-sm mt-1">Platform ayarlarını yapılandırın</p>
      </div>

      {saved && (
        <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex items-center gap-3">
          <i className="ri-checkbox-circle-line text-green-600 text-xl" />
          <p className="text-green-800 font-medium text-sm">Ayarlar kaydedildi!</p>
        </div>
      )}

      <div className="flex flex-col lg:flex-row gap-6">
        {/* Sidebar nav */}
        <div className="lg:w-56 shrink-0">
          <div className="bg-white rounded-xl border border-slate-100 p-2">
            {sections.map(s => (
              <button key={s.id} onClick={() => setActiveSection(s.id)}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors mb-0.5 ${activeSection === s.id ? 'bg-[#1e3a5f] text-white' : 'text-slate-600 hover:bg-slate-50'}`}>
                <i className={s.icon} />
                {s.label}
              </button>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="flex-1">
          {activeSection === 'genel' && (
            <div className="bg-white rounded-xl border border-slate-100 p-6 space-y-5">
              <h2 className="text-base font-semibold text-slate-800">Genel Ayarlar</h2>
              <div>
                <label className="block text-xs font-medium text-slate-600 mb-1">Platform Adı</label>
                <input value={platformName} onChange={e => setPlatformName(e.target.value)} className="w-full px-3 py-2.5 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#1e3a5f]/20" />
              </div>
              <div>
                <label className="block text-xs font-medium text-slate-600 mb-1">Varsayılan Hak Ediş Oranı (%)</label>
                <input type="number" min={0} max={100} value={commissionRate} onChange={e => setCommissionRate(Number(e.target.value))} className="w-full px-3 py-2.5 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#1e3a5f]/20" />
                <p className="text-xs text-slate-400 mt-1">Yeni öğretmenler için varsayılan hak ediş oranı</p>
              </div>
              <div>
                <label className="block text-xs font-medium text-slate-600 mb-1">Varsayılan Deneme Dersi Süresi</label>
                <select value={trialDuration} onChange={e => setTrialDuration(e.target.value)} className="w-full px-3 py-2.5 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#1e3a5f]/20">
                  <option>20 dk</option><option>40 dk</option><option>Diğer</option>
                </select>
              </div>
              <button onClick={save} className="px-6 py-2.5 rounded-lg bg-[#1e3a5f] text-white text-sm font-medium hover:bg-[#162d4a] transition-colors">Kaydet</button>
            </div>
          )}

          {activeSection === 'branches' && (
            <div className="bg-white rounded-xl border border-slate-100 p-6 space-y-4">
              <h2 className="text-base font-semibold text-slate-800">Branş Listesi</h2>
              <div className="flex gap-2">
                <input value={newBranch} onChange={e => setNewBranch(e.target.value)} onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addBranch())} placeholder="Yeni branş ekle..." className="flex-1 px-3 py-2 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#1e3a5f]/20" />
                <button onClick={addBranch} className="px-4 py-2 rounded-lg bg-[#1e3a5f] text-white text-sm font-medium hover:bg-[#162d4a] whitespace-nowrap">Ekle</button>
              </div>
              <div className="flex flex-wrap gap-2">
                {branches.map(b => (
                  <div key={b} className="flex items-center gap-1.5 bg-indigo-50 px-3 py-1.5 rounded-full">
                    <span className="text-indigo-700 text-sm font-medium">{b}</span>
                    <button onClick={() => removeBranch(b)} className="text-indigo-400 hover:text-indigo-700 cursor-pointer">
                      <i className="ri-close-line text-xs" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeSection === 'grades' && (
            <div className="bg-white rounded-xl border border-slate-100 p-6 space-y-4">
              <h2 className="text-base font-semibold text-slate-800">Sınıf Seviyeleri</h2>
              <div className="flex gap-2">
                <input value={newGrade} onChange={e => setNewGrade(e.target.value)} onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addGrade())} placeholder="Yeni sınıf seviyesi ekle..." className="flex-1 px-3 py-2 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#1e3a5f]/20" />
                <button onClick={addGrade} className="px-4 py-2 rounded-lg bg-[#1e3a5f] text-white text-sm font-medium hover:bg-[#162d4a] whitespace-nowrap">Ekle</button>
              </div>
              <div className="flex flex-wrap gap-2">
                {grades.map(g => (
                  <div key={g} className="flex items-center gap-1.5 bg-slate-100 px-3 py-1.5 rounded-full">
                    <span className="text-slate-700 text-sm font-medium">{g}</span>
                    <button onClick={() => removeGrade(g)} className="text-slate-400 hover:text-slate-700 cursor-pointer">
                      <i className="ri-close-line text-xs" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeSection === 'statuses' && (
            <div className="bg-white rounded-xl border border-slate-100 p-6 space-y-5">
              <h2 className="text-base font-semibold text-slate-800">Durum Listeleri</h2>
              {[
                { title: 'Başvuru Durumları', items: settings.applicationStatuses, color: 'bg-blue-50 text-blue-700' },
                { title: 'Ders Durumları', items: settings.lessonStatuses, color: 'bg-green-50 text-green-700' },
                { title: 'Ödeme Durumları', items: settings.paymentStatuses, color: 'bg-amber-50 text-amber-700' },
              ].map(g => (
                <div key={g.title}>
                  <h3 className="text-sm font-semibold text-slate-700 mb-2">{g.title}</h3>
                  <div className="flex flex-wrap gap-2">
                    {g.items.map(i => (
                      <span key={i} className={`px-3 py-1.5 rounded-full text-xs font-medium ${g.color}`}>{i}</span>
                    ))}
                  </div>
                </div>
              ))}
              <p className="text-xs text-slate-400">Durum listeleri PHP API bağlantısı ile düzenlenebilir hale gelecek.</p>
            </div>
          )}

          {activeSection === 'roles' && (
            <div className="bg-white rounded-xl border border-slate-100 p-6 space-y-4">
              <h2 className="text-base font-semibold text-slate-800">Kullanıcı Rolleri</h2>
              <div className="space-y-3">
                {[
                  { role: 'Yönetici', desc: 'Tüm panele tam erişim. Başvuru, öğrenci, öğretmen, ödeme ve rapor yönetimi.', icon: 'ri-shield-star-line', color: 'text-[#1e3a5f]', bg: 'bg-[#1e3a5f]/5' },
                  { role: 'Öğretmen', desc: 'Sadece kendi öğrencileri, dersleri, dekontları ve kazançlarını görebilir.', icon: 'ri-user-star-line', color: 'text-purple-600', bg: 'bg-purple-50' },
                ].map(r => (
                  <div key={r.role} className={`${r.bg} rounded-xl p-4 flex items-start gap-4`}>
                    <div className="w-10 h-10 flex items-center justify-center bg-white rounded-xl shadow-sm shrink-0">
                      <i className={`${r.icon} ${r.color}`} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-slate-800">{r.role}</h3>
                      <p className="text-xs text-slate-500 mt-0.5">{r.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-xs text-slate-400">Rol yönetimi ve yetkilendirme PHP API bağlantısı ile yapılandırılacak.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}